import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch} from "react-redux";
import {BeaconModal} from "../Shared/Modal/BeaconModal";
import ReactModalContent from "../Shared/Modal/ReactModalContent";
import ReactModalHeader from "../Shared/Modal/ReactModalHeader";
import Indicator from "../../assets/indicator.svg";
import styled from 'styled-components';
import {ProfileBeaconCheckbox} from "../Shared/ProfileBeaconComponents";
import ReactModalFooter from "../Shared/Modal/ReactModalFooter";
import {ANALYTICS_IDS} from "../../utils/analyticsTrackingConstants";
import {UseAppSelector} from "../../redux/configure-store";
import {
    getIsPricesInvOptionsChecked,
    getPlanProducts,
    getSelectedPricesServiceProducts,
    getServiceProducts
} from "../../redux/profile/selectors";
import {
    setIsPricesInvOptionsChecked, setSelectedPricesServiceProducts
} from "../../redux/profile/slice";
import _ from "lodash";

const StyledContainer = styled.div`

`;

const StyledContent = styled.div`
  margin-top: 32px;
  padding-bottom: 34px;
  border-bottom: solid 2px #e9ebed;
  @media (max-width: 640px){
    padding-bottom: 24px;
  }
`;

const ImageContent  = styled.div`
  @media (max-width: 640px){
    margin-left:-6px;
  }
`;

const StyledCheckboxContainer = styled.div`
  padding-top: 14px;
`;

const StyledSection = styled.div`
  margin-top: 28px;
  @media (max-width: 768px){
    margin-top: 24px;
    margin-bottom: 24px;
  }
  @media (max-width: 640px){
    margin-top: 16px;
    margin-bottom: 22px;
  }
`;

const StyledHeader = styled.div`
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-size: 20px;
  font-weight: var(--beacon-font-weight-bold);
  line-height: 1.4;
  letter-spacing: 0.02px;
  padding-bottom: 12px;
  @media (max-width: 768px) {
    font-size: 16px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
\` ;
  @media (max-width: 640px){
    font-size: 16px;
    padding-top:0px;
    padding-bottom: 16px;
  }
`;
const StyledHeaderCheckbox = styled(ProfileBeaconCheckbox)`
  --beacon-form-label-font-size: 18px;
  @media (max-width: 768px) {
    --beacon-form-label-font-size: 16px;
  }
  @media (max-width: 640px){
    --beacon-form-label-font-size: 14px;
  }
`;

const StyledCheckbox = styled(ProfileBeaconCheckbox)`
  padding-top: 10px;
  padding-bottom: 10px;
  --beacon-form-label-font-size: 18px;
  @media (max-width: 768px) {
    --beacon-form-label-font-size: 16px;
  }
  @media (max-width: 640px){
    --beacon-form-label-font-size: 14px;
  }
`;

export const DailyPricesInvestmentOptionsModal = ({modalName, handleCloseModal,dispatchOverlayLoad}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const overlay = "Daily Prices Investment Options Modal";
        dispatchOverlayLoad(overlay);
    }, []);

    const filteredPlanProducts = UseAppSelector(getPlanProducts);
    const getFilteredFunds = (fundName: string ) => {
        return filteredPlanProducts?.filter((product: any) => product.globalFundGroupName === fundName);
    }

    const stockFunds = _.orderBy(getFilteredFunds("STOCKS"), 'longName', 'asc');
    const bondFunds = _.orderBy(getFilteredFunds("BONDS"), 'longName', 'asc');
    const moneyMarketFunds = _.orderBy(getFilteredFunds("MONEY MARKET/ STABLE VALUE"), 'longName', 'asc');
    const retirementFunds = _.orderBy(getFilteredFunds("RETIREMENT").concat(getFilteredFunds("RETIREMENT FUNDS")), 'longName', 'asc');
    const companyStockFunds = _.orderBy(getFilteredFunds("COMPANY STOCK"), 'longName', 'asc');

    const invOptionsChecked = UseAppSelector(getIsPricesInvOptionsChecked);
    const selectedServiceProducts = UseAppSelector(getSelectedPricesServiceProducts);
    const [selectedFunds, setSelectedFunds] = useState(selectedServiceProducts);
    const isInvOptionsChecked = selectedFunds.length === selectedServiceProducts.length ? false : invOptionsChecked;

    const getFooter = (checked: any) => {
        return <ReactModalFooter
            tertiaryButtonText={"Cancel"}
            primaryButtonText={"Update"}
            handleCancelClick={handleCloseModal}
            handleOnClick={() => updateInvestments()}
            tertiaryButtonId={ANALYTICS_IDS.InvOptionsModalSkipCancel}
            primaryButtonId={ANALYTICS_IDS.InvOptionsModalUpdateFunds}
            primaryButtonDisabled={!checked && true}
        />
    };

    const updateInvestments = () => {
        dispatch(setSelectedPricesServiceProducts(selectedFunds));
        if(isInvOptionsChecked)
            handleCloseModal();
    }

    const handleSelectAll = (event: any) => {
        let value = event.target.checked;
        if (value) {
            const planProductsCodes = filteredPlanProducts.map((product: any) => product.code);
            setSelectedFunds(planProductsCodes);
            dispatch(setIsPricesInvOptionsChecked(true));
        }
        else {
            setSelectedFunds([]);
            dispatch(setIsPricesInvOptionsChecked(false));
        }
    }

    const handleServiceProductsChange = (event: any) => {
        if (event.target.checked){
            setSelectedFunds([event.target.value, ...selectedFunds]);
            dispatch(setIsPricesInvOptionsChecked(true));
        }
        else {
            const funds = selectedFunds.filter((serviceProduct: any) => serviceProduct !== event.target.value)
            setSelectedFunds(funds);
            if(funds.length == 0){
                dispatch(setIsPricesInvOptionsChecked(false));
            }
        }
    }

    return (
        <React.Fragment>
            <BeaconModal id={modalName} footer={getFooter(isInvOptionsChecked)} actionZone={true}>

                <ReactModalContent>
                    <StyledContainer>
                        <ReactModalHeader modalTitle="Select investments in your plan"/>
                        Choose at least one investment to sign up for a subscription.
                        <StyledContent>
                            <ImageContent>
                                <img src={Indicator} alt="Indicator icon"/> Indicates your investment
                            </ImageContent>
                            <StyledCheckboxContainer>
                                <StyledHeaderCheckbox label="Select All" checked={selectedFunds.length == filteredPlanProducts.length} onInput={handleSelectAll}/>
                            </StyledCheckboxContainer>
                        </StyledContent>
                        { stockFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                STOCKS
                            </StyledHeader>
                            {stockFunds.map((fund: any) => {
                                return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                                       value={fund.code} checked={selectedFunds.includes(fund.code)} />
                            })
                            }
                        </StyledSection>
                        }
                        { bondFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                BONDS
                            </StyledHeader>
                            {bondFunds.map((fund: any) => {
                                return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                                       value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                            })
                            }
                        </StyledSection>
                        }
                        { moneyMarketFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                MONEY MARKET / STABLE VALUE
                            </StyledHeader>
                            {moneyMarketFunds.map((fund: any) => {
                                return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                                       value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                            })
                            }
                        </StyledSection>
                        }
                        { retirementFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                RETIREMENT
                            </StyledHeader>
                            {retirementFunds.map((fund: any) => {
                                return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                                       value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                            })
                            }
                        </StyledSection>
                        }
                        { companyStockFunds?.length > 0 &&
                        <StyledSection>
                            <StyledHeader>
                                COMPANY STOCK
                            </StyledHeader>
                            {companyStockFunds.map((fund: any) => {
                                return <StyledCheckbox label={fund.longName} onInput={handleServiceProductsChange}
                                                       value={fund.code} checked={selectedFunds.includes(fund.code)}/>
                            })
                            }
                        </StyledSection>
                        }
                    </StyledContainer>
                </ReactModalContent>
            </BeaconModal>
        </React.Fragment>
    )
}